module.exports = __webpack_public_path__ + "static/media/chevron-down-blue.ceb1c929.svg";